import Vue from "vue";
import VueRouter from "vue-router";
import "firebase/auth";
import firebase from "firebase/app";
import Home from "../views/Home.vue";
import NoGame from "../views/NoGame.vue";
import Live from "../views/Live.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/live",
    name: "Live",
    component: Live
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue")
  },
  {
    path: "/forgot",
    name: "Forgot",
    component: () => import("../views/forgot.vue")
  },
  {
    path: "/nogame",
    name: "No Game",
    component: NoGame
  },
  {
    path: "/admin",
    name: "Admin",
    meta: {
      auth: true
    },
    component: () => import("../views/Admin.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

// firebase.auth().currentUser is null until the SDK has restored the session,
// so the first guarded navigation waits for that one-off signal. Registering a
// fresh onAuthStateChanged listener per navigation (as this used to) leaks one
// listener per route change and resolves against a stale user after re-login.
let authReady;
function whenAuthReady() {
  if (!authReady) {
    authReady = new Promise((resolve) => {
      const unsubscribe = firebase.auth().onAuthStateChanged(() => {
        unsubscribe();
        resolve();
      });
    });
  }
  return authReady;
}

router.beforeEach(async (to, from, next) => {
  if (!to.meta.auth) {
    return next();
  }
  await whenAuthReady();
  next(firebase.auth().currentUser ? undefined : "/login");
});

export default router;
